import { Map } from 'immutable';
import ShortAnswer from './model';
import {
  FETCH_SHORT_ANSWER_SUCCESS,
} from './actions';

export default function WritingAssignmentActivityReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_SHORT_ANSWER_SUCCESS:
      return onFetchSuccess(state, action);
    default:
      return state;
  }
}

function onFetchSuccess(state, action) {
  const { activityId, studentId, payload } = action;
  return state.set(`${activityId}-${studentId}`, ShortAnswer.create(payload));
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/reducer.js